module.exports = __webpack_public_path__ + "static/img/erweima2.ed81756.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/erweima2.png
// module id = aKpv
// module chunks = 1